import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای جابجایی شیفت بین نفرات (Shift Swaps)

گاهی نیاز است که دو اپراتور شیفت‌های کاری خود را با یکدیگر جابه‌جا کنند. این صفحه به شما اجازه می‌دهد تا این جابجایی‌ها را به شکل ساختاریافته ثبت و مدیریت کنید.

## ۱. ثبت درخواست جابجایی
برای درخواست جابه‌جایی دو شیفت، از فرم تعبیه شده در بالای صفحه استفاده کنید:

- **اپراتور اول (A) و تاریخ شیفت او:** شخصی که قرار است شیفت خود را واگذار کند، به همراه تاریخ شیفتی که در آن حضور نخواهد داشت.
- **اپراتور دوم (B) و تاریخ شیفت او:** شخصی که قرار است جایگزین اپراتور اول شود، به همراه تاریخ شیفت اصلی خودش که آن را واگذار خواهد کرد.
- **دلیل:** توضیحی کوتاه از علت جابجایی بین دو پرسنل.

مثال: اگر اپراتور A بخواهد شیفت روز شنبه‌ی خود را با شیفت روز یکشنبه‌ی اپراتور B جابجا کند، این تاریخ‌ها در فرم ثبت خواهند شد و در نتیجه، اپراتور A روز یکشنبه می‌آید و اپراتور B روز شنبه.

## ۲. بررسی و تأیید جابجایی‌ها
درست مانند مرخصی‌ها، درخواست‌های ثبت شده در ابتدا وضعیت «در انتظار (Pending)» دارند و باید توسط سرپرست یا مدیر سیستم تأیید شوند.
در جدول پایین صفحه:
- از دکمه‌ی **«تأیید»** برای پذیرش جابجایی استفاده کنید. با این کار سیستم این تغییر را در برنامه‌ی کاری (Roster) مؤثر هر دو اپراتور اعمال خواهد کرد.
- از دکمه‌ی **«رد»** برای جلوگیری از این جابجایی استفاده کنید.

وضعیت شیفت هر اپراتور پس از تأیید نهایی، در بخش محاسبه شیفت‌های مؤثر به صورت اتوماتیک به‌روزرسانی می‌شود.


export default Layout;
